<div class="tab-pane" role="tabpanel" id="permisos">
    <fieldset id="agregar_perm_resol" class="">
        <div class="step_section">
            <h3 class="form-signin-heading"><strong>Permisos y Resoluciones</strong></h3>
            <hr />
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">


                        <div class="form-horizontal">
                            <div class="form-group" align="left">
                                <label for="perm_numero" class="col-md-2">N&uacute;mero Permiso(<span style="color:red; font-size: 17px">*</span>)</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="N&uacute;mero Permiso" id="perm_numero" name="perm_numero" formControlName="perm_numero" [errorStateMatcher]="matcher">
                                        <mat-error *ngIf="form.controls['perm_numero'].hasError('pattern')">
                                            Solo se permiten caracteres <strong>numéricos</strong>
                                        </mat-error>  
                                        <mat-error *ngIf="form.controls?.perm_numero.hasError('required')">
                                            Este campo es <strong>obligatorio</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <label for="perm_fecha" class="col-md-1" style="padding-left: 30px;">Fecha(<span style="color:red; font-size: 17px">*</span>)</label>
                                <div class="col-md-2" style="padding-left: 40px;">
                                    <mat-form-field class="dateinput">
                                        <input matInput [matDatepicker]="dp3" [max]="maxDate" formControlName="perm_fecha" disabled>
                                        <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                                        <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1"></div>
                                <label for="superfm2" class="col-md-1" style="padding-left: 0px;">Superficie M2</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Superficie M2" id="superfm2" name="superfm2" formControlName="superfm2" [errorStateMatcher]="matcher">
                                        <span matSuffix>m²</span>
                                        <mat-error *ngIf="form.controls?.superfm2.hasError('required')">
                                            Este campo es <strong>obligatorio</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-md-12" style="padding-top: 20px"></div>
                            <div class="form-group" align="left">
                                <label for="modproy" class="col-md-3">Cuenta con Modificacion de Proyecto Aprobada</label>
                                <div class="col-md-2 inline" style="padding-top: 20px;">
                                    <mat-radio-group formControlName="modproy">
                                        <mat-radio-button style="padding-right: 20px" name="modproy" value="SI">SI</mat-radio-button>
                                        <mat-radio-button style="padding-right: 20px" name="modproy" value="NO">NO</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                                <label for="resolucion" class="col-md-1" style="margin-right: 10px ; padding-left: 0px">Resolución</label>
                                <div class="col-md-2" style="padding-left: 10px;">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Resolución" id="resolucion" name="resolucion" formControlName="resolucion" [errorStateMatcher]="matcher">
                                    </mat-form-field>
                                </div>
                                <label for="fecha_resol" class="col-md-1" style="padding-left: 15px;">Fecha</label>
                                <div class="col-md-2">
                                    <mat-form-field class="dateinput">
                                        <input matInput [matDatepicker]="dp4" id="fecha_resol" [max]="maxDate" name="fecha_resol" formControlName="fecha_resol">
                                        <mat-datepicker-toggle matSuffix [for]="dp4"></mat-datepicker-toggle>
                                        <mat-datepicker #dp4 disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-md-12" style="padding-top: 20px"></div>
                            <div class="form-group">
                                <label for="perm_prim" class="col-md-1" *ngIf="n_form != '1.7'">Permiso Primitivo Nro</label>
                                <label for="perm_prim" class="col-md-1" *ngIf="n_form == '1.7'">Permiso de la vivienda que se amplía N°</label>
                                

                                <div class="col-md-1">
                                    <mat-form-field class="example-full-width" style="width: 90px;">
                                        <input matInput placeholder="Permiso primitivo Nro" id="perm_prim" name="perm_prim" formControlName="perm_prim" [errorStateMatcher]="matcher">
                                    </mat-form-field>
                                </div>
                                <label for="fecha_prim" class="col-md-1" style="margin-left: 40px; padding-right: 0px">Fecha</label>
                                <div class="col-md-1" style="padding-left: 0px;">
                                    <mat-form-field class="dateinput" style="width: 90px; ">
                                        <input matInput [matDatepicker]="dp5" id="fecha_prim" [max]="maxDate" name="fecha_prim" formControlName="fecha_prim">
                                        <mat-datepicker-toggle matSuffix [for]="dp5"></mat-datepicker-toggle>
                                        <mat-datepicker #dp5 disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <label for="recepcion" class="col-md-1" style="margin-left: 40px; padding-left: 0px; margin-right: 5px">Recepción</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Recepción" id="recepcion" name="recepcion" formControlName="recepcion" [errorStateMatcher]="matcher">
                                    </mat-form-field>
                                </div>
                                <label for="fecha_recep" class="col-md-1" style="margin-left: 5px">Fecha</label>
                                <div class="col-md-2">
                                    <mat-form-field class="dateinput">
                                        <input matInput [matDatepicker]="dp6" id="fecha_recep" [max]="maxDate" name="fecha_recep" formControlName="fecha_recep">
                                        <mat-datepicker-toggle matSuffix [for]="dp6"></mat-datepicker-toggle>
                                        <mat-datepicker #dp6 disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="form-group">
                                <div align="center" class="col-md-12">
                                    <button mat-raised-button color="primary" style="padding-top: 5px" id="ingreso_permiso" (click)="add_Permisos()">
                                            Agregar Permisos
                                        <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="datatable_antecedentes">
                        <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>PERMISO NUM</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.perm_numero}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>FECHA</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.perm_fecha}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>SUPERFICIE</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.superfm2}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>MODIFIC</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <strong *ngIf="row.modproy == 'SI'">Si</strong>
                                    <strong *ngIf="row.modproy == 'NO'">No</strong>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>RESOL</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.resolucion}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>FECHA</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.fecha_resol}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>PERMISO PRIM</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.perm_prim}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>OPCIONES</span>
                                </ng-template>
                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                    <span (click)="get_Permisos(rowIndex)" style="padding-right: 5px;"><i class="glyphicon glyphicon-pencil"></i></span>
                                    <span (click)="delete_Permisos(rowIndex)"><i class="glyphicon glyphicon-trash"></i></span>
                                </ng-template>
                            </ngx-datatable-column>

                        </ngx-datatable>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
    <!--Modal-->
    <ng-template #openModal>
        <h2 mat-dialog-title>Ingresar informaci&oacute;n de los Permisos</h2>
        <mat-dialog-content>

            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Permiso para el que se solicita esta recepcion</strong>
                </div>
                <div class="form-group">
                    <label class="col-md-3" for="tipo">N&uacute;mero Permiso</label>
                    <div class="col-md-3">
                        <input id="id" name="id" type="hidden" [(ngModel)]="temp_perm.id">
                        <input id="perm_numero" name="perm_numero" type="text" placeholder="perm_numero" [(ngModel)]="temp_perm.perm_numero"  class="form-control input-md">
                    </div>
                    <label class="col-md-3" for="perm_fecha">Fecha</label>
                    <div class="col-md-3">
                        <input id="perm_fecha" name="perm_fecha" type="text" placeholder="Fecha permiso" [(ngModel)]="temp_perm.perm_fecha" class="form-control input-md" />
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-3" for="superfm2">Superficie M2</label>
                    <div class="col-md-3">
                        <input id="superfm2" name="superfm2" type="text" placeholder="Superficie" [(ngModel)]="temp_perm.superfm2" class="form-control input-md" />
                    </div>
                    <label class="col-md-3" for="modproy">Mofificacion</label>
                    <div class="col-md-3">
                        <div class="col-md-6">
                            <label style="padding-right: 20px">SI </label>
                            <input style="width: 21px" type="radio" id="modproy" name="modproy" value="SI" [(ngModel)]="temp_perm.modproy" class="form-control input-md" />
                        </div>
                        <div class="col-md-6">
                            <label style="padding-right: 20px">NO </label>
                            <input style="width: 21px" type="radio" id="modproy" name="modproy" value="NO" [(ngModel)]="temp_perm.modproy" class="form-control input-md" />
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-3" for="resolucion">Resolucion</label>
                    <div class="col-md-3">

                        <input id="resolucion" name="resolucion" type="text" placeholder="resolucion" [(ngModel)]="temp_perm.resolucion" class="form-control input-md" />

                    </div>
                    <label class="col-md-3" for="fecha_resol">Fecha Resol.</label>
                    <div class="col-md-3">

                        <input id="fecha_resol" name="fecha_resol" type="text" placeholder="Fecha Resol." [(ngModel)]="temp_perm.fecha_resol" class="form-control input-md" />

                    </div>

                </div>
                <div class="form-group">
                    <label class="col-md-3" for="perm_prim">Permiso Primitivo</label>
                    <div class="col-md-3">

                        <input id="perm_prim" name="perm_prim" type="text" placeholder="Permiso Primitivo" [(ngModel)]="temp_perm.perm_prim" class="form-control input-md" />

                    </div>

                    <label class="col-md-3" for="fecha_prim">Fecha Perm. Prim.</label>
                    <div class="col-md-3">

                        <input id="fecha_prim" name="fecha_prim" type="text" placeholder="Fecha Perm. Prim." [(ngModel)]="temp_perm.fecha_prim" class="form-control input-md" />

                    </div>

                </div>
                <div class="form-group">
                    <label class="col-md-3" for="recepcion">Recepcion</label>
                    <div class="col-md-3">

                        <input id="recepcion" name="recepcion" type="text" placeholder="Recepcion" [(ngModel)]="temp_perm.recepcion" class="form-control input-md" />

                    </div>
                    <label class="col-md-3" for="fecha_recep">Fecha Recepcion</label>
                    <div class="col-md-3">

                        <input id="fecha_recep" name="fecha_recep" type="text" placeholder="Fecha Recep." [(ngModel)]="temp_perm.fecha_recep" class="form-control input-md" />

                    </div>

                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_permiso" data-dismiss="modal" (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id=" ingreso_proyecto" (click)="save_Permisos() ">Ingresar Permiso <i class="fa fa-user-o " aria-hidden="true "></i></button>

        </mat-dialog-actions>
    </ng-template>
</div>

<ng-template #openModalNODATA>
    <h2 mat-dialog-title>Ingrese datos</h2>
    <mat-dialog-content>
       No ingreso ningun dato del permiso.
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal" (click)="cleanData()">Aceptar</button>
    </mat-dialog-actions>
</ng-template>

<div class="separator"></div>